// extracted by mini-css-extract-plugin
export var numpadContainer = "_qk-1";
export var phoneButton = "_qk-0";